module.exports = __webpack_public_path__ + "media/images/icons/cbi1-ea832c649078888ae1f80d045c709d33.svg";